export enum InsuranceDropdownVisibility {
  REQUIRED = 'required',
  OPTIONAL = 'optional',
  HIDDEN = 'hidden',
}
